// src/context/FilterContext.js

import React, {
  createContext,
  useState,
  useEffect,
  useContext
} from 'react';
import { LocationContext } from './LocationContext';

export const FilterContext = createContext();

const defaultFilters = {
  species: null,
  sex: null,
  location: {
    address: "",  // texto
    lat: null,    // latitud
    lng: null,    // longitud
    radius: null  // radio en km
  }
};

export const FilterProvider = ({ children }) => {
  // 1) Sacamos la ubicación actual / por defecto del LocationContext
  const { location: userLocation } = useContext(LocationContext);
  // userLocation debe tener la forma { address, lat, lng, radius }

  // 2) Cargamos los filtros que hubiera en localStorage (si existen)
  const stored = localStorage.getItem("filters");
  const initialFilters = stored
    ? JSON.parse(stored)
    : defaultFilters;

  // 3) Estado local de filtros, inicializado con lo que había en localStorage o los por defecto
  const [filters, setFilters] = useState(initialFilters);

  // 4) Siempre que cambie userLocation, **sobrescribimos** sólo la parte de ubicación
  useEffect(() => {
    if (userLocation && userLocation.lat != null && userLocation.lng != null) {
      setFilters(prev => ({
        ...prev,
        location: {
          address: userLocation.address || prev.location.address || "",
          lat: userLocation.lat,
          lng: userLocation.lng,
          // mantenemos el radius que el usuario hubiera elegido, o si es null, usamos el de userLocation
          radius:
            prev.location.radius != null
              ? prev.location.radius
              : userLocation.radius
        }
      }));
    }
  }, [userLocation]);

  // 5) Persistimos TODHO el objeto filters en localStorage cada vez que cambie
  useEffect(() => {
    localStorage.setItem("filters", JSON.stringify(filters));
  }, [filters]);

  return (
    <FilterContext.Provider value={{ filters, setFilters }}>
      {children}
    </FilterContext.Provider>
  );
};
